import { isDomain } from "../../utils/htmlReportsUtils";

export const generateConversationId = () => {
  const now = new Date();
  const date = now.toISOString().split("T")[0]; // YYYY-MM-DD
  const time = now.toTimeString().split(" ")[0].replace(/:/g, ""); // HHMMSS
  const randomSuffix = Math.random().toString(36).substring(2, 6);
  const prefixAppName = isDomain("researchcdn.nomuranow.com") ? "Report" : "GRP"; // prefix with appname
  return `${prefixAppName}-${date}-${time}-${randomSuffix}`;
};
